import React from 'react';
import {
  PreviewContainer,
  PreviewHeader,
  SectionSubtitle,
  SectionTitle,
  StepContent,
  StepDesc,
  StepItem,
  StepNumber,
  StepsList,
  StepTitle,
  VkAvatar,
  VkCard,
  VkCta,
  VkHeader,
  VkHeadline,
  VkImageMock,
  VkMeta,
  VkBusinessName,
  VkTags,
  VkTextContent,
  VkTime,
  Wrapper,
} from './styles';
import sampleImage from "../../sample-image.jpeg";
import sampleLogo from "../../sample-logo.jpeg";
import {useLandingContext} from "../../../Landing";

export default function PostStructure() {
  const {APP_DATA} = useLandingContext();
  const { postStructureTitle, postStructureSubtitle, samplePost, postStructureItems, samplePostTitle, samplePostSubTitle } = APP_DATA;

  return (
    <Wrapper>
      <SectionTitle>{postStructureTitle}</SectionTitle>
      <SectionSubtitle>{postStructureSubtitle}</SectionSubtitle>

      <StepsList>
        {postStructureItems.map((item, index) => (
          <StepItem key={index}>
            <StepNumber>{item.step}</StepNumber>
            <StepContent>
              <StepTitle>{item.title}</StepTitle>
              <StepDesc>{item.desc}</StepDesc>
            </StepContent>
          </StepItem>
        ))}
      </StepsList>

      <PreviewContainer>
        <PreviewHeader>
          <span>{samplePostTitle}</span>
          <span>✨ {samplePostSubTitle}</span>
        </PreviewHeader>
        <VkCard>
          <VkHeader>
            <VkAvatar style={{background: `url(${sampleLogo}) center / 100% 100% no-repeat`}}/>
            <VkMeta>
              <VkBusinessName>{samplePost.businessName}</VkBusinessName>
              <VkTime>{samplePost.time}</VkTime>
            </VkMeta>
          </VkHeader>
          <VkImageMock style={{background: `url(${sampleImage}) center`}}/>
          <VkTextContent>
            <VkHeadline>{samplePost.headline}</VkHeadline>
            <span>{samplePost.text}</span>
            <VkCta>{samplePost.cta}</VkCta>
            <VkTags>{samplePost.tags}</VkTags>
          </VkTextContent>
        </VkCard>
      </PreviewContainer>
    </Wrapper>
  );
}
